import { useState } from 'react';
import { errorText } from '../../utils/errorText';
import { button, input, label } from '../shared/styles';

/*
 * The small inline forms of the Quality page. `fields` are
 * {name, label?, type?, size?, initial?, options?, tip?, required?}; an option is a key of the
 * `opt_` catalogue, or {value, label} for data (a plan, a parameter).
 */
export default function Form({ fields, submitLabel, submitTip, onSubmit, testId, t }) {
  const blank = () => Object.fromEntries(fields.map((f) => [f.name, f.initial ?? '']));
  const [values, setValues] = useState(blank);
  const [error, setError] = useState('');
  const set = (name, value) => setValues((v) => ({ ...v, [name]: value }));
  const submit = async (e) => {
    e.preventDefault();
    setError('');
    // The server refuses these blank (iso.py _text); say so before sending.
    const missing = fields.find((f) => f.required && !String(values[f.name] ?? '').trim());
    if (missing) {
      setError(t('fieldRequired', { field: t(missing.label || missing.name) }));
      return;
    }
    try {
      await onSubmit(values);
      setValues(blank());
    } catch (err) {
      setError(errorText(err));
    }
  };
  return (
    <form onSubmit={submit} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }} data-testid={testId}>
      {fields.map((f) => (
        <label key={f.name} style={{ ...label, marginBottom: 0 }}>{t(f.label || f.name)}
          {f.options ? (
            <select style={input} value={values[f.name]} onChange={(e) => set(f.name, e.target.value)}
              title={f.tip ? t(f.tip) : undefined} data-testid={`${testId}-${f.name}`}>
              {f.options.map((o) => (typeof o === 'string'
                ? <option key={o} value={o}>{t(`opt_${o}`)}</option>
                : <option key={o.value} value={o.value}>{o.label}</option>))}
            </select>
          ) : f.type === 'checkbox' ? (
            <input type="checkbox" checked={!!values[f.name]} title={f.tip ? t(f.tip) : undefined} data-testid={`${testId}-${f.name}`}
              onChange={(e) => set(f.name, e.target.checked)} />
          ) : f.type === 'textarea' ? (
            <textarea style={input} rows={2} value={values[f.name]} title={f.tip ? t(f.tip) : undefined} data-testid={`${testId}-${f.name}`}
              onChange={(e) => set(f.name, e.target.value)} />
          ) : (
            <input style={input} type={f.type || 'text'} value={values[f.name]} size={f.size} required={f.required}
              title={f.tip ? t(f.tip) : undefined} data-testid={`${testId}-${f.name}`} onChange={(e) => set(f.name, e.target.value)} />
          )}
        </label>
      ))}
      <button type="submit" style={button('var(--c-primary)')} title={submitTip ? t(submitTip) : undefined}
        data-testid={`${testId}-submit`}>{t(submitLabel)}</button>
      {error && <p role="alert" style={{ color: 'var(--c-danger-fg)', width: '100%' }}>{error}</p>}
    </form>
  );
}
